import React, { useState, useEffect, useRef } from 'react'
import './CustomTooltips.css'
import { Step, TooltipRenderProps } from 'react-joyride'

interface content {
  tutorialTxt: React.ReactNode;
  style: string;
}

export interface CustomStep extends Step {
  data: {
    contents: Array<content>
    buttonLabel?: string
    displayWord?: string
  }
}

type CustomTooltipProps = TooltipRenderProps & {
  spotlightClicks?: boolean
}

export const CustomTooltips = ({
  continuous,
  step,
  primaryProps,
  tooltipProps,
  spotlightClicks = false,
}: CustomTooltipProps) => {
  const customStep = step as CustomStep
  const [disabled, setDisabled] = useState<boolean>(!spotlightClicks)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
 
  useEffect(() => {
    if (disabled) {
      const time = customStep.data?.contents?.length * 1000 || 1500;
      timer.current = setTimeout(() => {
        setDisabled(false)
      }, time)
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [disabled, customStep.data])

  const handleClick = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLDivElement>,
  ) => {
    if (disabled) {
      e.stopPropagation()
    } else {
      primaryProps.onClick?.(e as React.MouseEvent<HTMLButtonElement>)
      setDisabled(true)
    }
  }

  return (
    <div {...tooltipProps} className="joyrideTooltip" onClick={handleClick}>
      {customStep.data?.contents?.map((content, index) => (
        <p key={`step-content-${index}`} className={content.style}>
          {content.tutorialTxt}
        </p>
      ))}
      {continuous && (
        <button
          {...primaryProps}
          onClick={handleClick}
          className="nextButton"
          disabled={disabled}
        >
          {customStep.data?.buttonLabel}
        </button>
      )}
    </div>
  )
}
